module.exports = __webpack_public_path__ + "static/digitalNotification5-ed5d309baddb237fd5fa7bf8f9e476bd.png";